import { render, staticRenderFns } from "./norm-weight-tooltip.vue?vue&type=template&id=cc1fba0e"
import script from "./norm-weight-tooltip.vue?vue&type=script&lang=js"
export * from "./norm-weight-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports